import * as React from 'react';
import MoneyInput from './MoneyInput';

type MoneyInputProps = React.ComponentProps<typeof MoneyInput>;

function formatPercent(value?: number): string {
  return (value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Digita como o valor monetário: os dígitos entram pela direita e empurram os anteriores para a esquerda.
const PercentInput = React.forwardRef<HTMLInputElement, Omit<MoneyInputProps, 'format'>>(
  function PercentInput(props, ref) {
    return <MoneyInput {...props} ref={ref} format={formatPercent} />;
  },
);

export default PercentInput;
